export const getFileExtension = (fileName: string) => {
  let fileExt = '';
  if (fileName) {
    fileExt = fileName.substr((Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1)
  }
  return fileExt;
}